/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'

export const userEventTypeV4NameSchema = z
  .enum([
    'None',
    'ProcessInternApplication',
    'SignAgreement',
    'AcceptUser',
    'AcceptOrgInvite',
    'UnratedRecords',
    'InternAcceptedElsewhere',
    'InviteAccepted',
    'InviteDeclined',
    'OrgInviteWithdrawn',
    'OrgInviteExpired',
    'JoinedOrg',
    'JoinedEduAsStudent',
    'IndividualRoleAdded',
    'OrgRoleAdded',
    'OrgRoleRemoved',
    'RemovedFromOrg',
    'AddedToInternship',
    'MovedToAnotherGroup',
    'InternRevokedByEdu',
    'StudentDataEditedByEdu',
    'PasswordResetByEdu',
    'DiaryRecordGraded',
    'RecordDeletedBySupervisor',
    'ApplicationAccepted',
    'RecalledByEdu',
    'RecordsDeletedByEdu',
    'OrgAnswersDeletedByEdu',
    'AutopayPaid',
    'AutopayFailed',
    'InternshipDatesChangedByEdu',
    'InternAssignedByEdu',
    'ProcessEduGoLiveRequest',
    'EduGoLiveDeclined',
  ])
  .describe('Member names of UserEventTypeV4.')
